import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import  {unregister} from './registerServiceWorker';
import {Provider} from 'react-redux';
import {store} from "./reducers/_store";
import {MuiThemeProvider} from 'material-ui/styles';
import muiTheme from "./conf/mui-theme";
import {HashRouter, BrowserRouter} from 'react-router-dom';

if(process.env.NODE_ENV === 'development'){
    ReactDOM.render(
        <Provider store={store}>
            <HashRouter>
                <MuiThemeProvider theme={muiTheme}>
                    <App />
                </MuiThemeProvider>
            </HashRouter>
        </Provider>
        , document.getElementById('root'));
} else {
    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter>
                <MuiThemeProvider theme={muiTheme}>
                    <App />
                </MuiThemeProvider>
            </BrowserRouter>
        </Provider>
        , document.getElementById('root'));
}

unregister();



// WEBPACK FOOTER //
// ./src/index.js